module.exports = __webpack_public_path__ + "img/goUp.aaf9b6a2.png";